import React from 'react';
import { useParams } from 'react-router-dom';

import BasePane from '@totem/components/BasePane';
import DateRangeContainer from '@totem/components/common/dateRangePicker/dateRangeContainer';
import ComponentHeader from '@totem/components/ComponentHeader';
import BilledTable from '@totem/components/ticketing/billing/billedTable';
import BillingContainer from '@totem/components/ticketing/billing/billingContainer';
import ContentLayout from '@totem/components/ui_components/page/ContentLayout';
import PrimaryContentPane from '@totem/components/ui_components/page/PrimaryContentPane';

const SingleBillingPage = () => {
  const { id } = useParams();

  return (
    <ContentLayout pageTitle="Billing" contentRight={<span />}>
      <BasePane>
        <PrimaryContentPane>
          <ComponentHeader title={'Billing'} />
          <DateRangeContainer defaultTimeFrame={'week'} allowClear>
            <BillingContainer billingId={id}>
              <BilledTable />
            </BillingContainer>
          </DateRangeContainer>
        </PrimaryContentPane>
      </BasePane>
    </ContentLayout>
  );
};

export default SingleBillingPage;
